import { Outlet, Link, useLocation } from 'react-router-dom'
import { BarChart3, Users } from 'lucide-react'
import { cn } from '@/lib/utils'
import { config } from '../../../config'

const links = [
	{ to: '/admin/analytics', label: 'Analytics', icon: BarChart3 },
	{ to: '/admin/users', label: 'Users', icon: Users },
]

export default function AdminLayout() {
	const location = useLocation()

	return (
		<div className="flex min-h-screen bg-muted/30">
			<aside className="w-[240px] border-r bg-background p-4">
				<Link to="/admin/users" className="mb-8 flex items-center">
					<img src={config.logo} alt={config.appName} className="h-9 w-auto object-contain" />
				</Link>
				<nav className="flex flex-col gap-1">
					{links.map((item) => {
						const Icon = item.icon
						const active = location.pathname.startsWith(item.to)
						return (
							<Link
								key={item.to}
								to={item.to}
								className={cn(
									'flex items-center gap-2 rounded-md px-3 py-2 text-sm',
									active
										? 'bg-primary/10 font-medium text-primary'
										: 'text-muted-foreground hover:bg-muted'
								)}
							>
								<Icon className="h-4 w-4" />
								{item.label}
							</Link>
						)
					})}
				</nav>
			</aside>
			<main className="min-w-0 w-full p-6">
				<Outlet />
			</main>
		</div>
	)
}
